import { create } from 'zustand';

/** Hell/Dunkel-Umschaltung (Tokens: `.dark`-Block in globals.css). */
export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'proerp-theme';

function systemTheme(): Theme {
  return typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

function readStored(): Theme | null {
  const value = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  return value === 'light' || value === 'dark' ? value : null;
}

function apply(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

const initial: Theme = readStored() ?? systemTheme();

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggle: () => void;
}

export const useTheme = create<ThemeState>((set, get) => ({
  theme: initial,
  setTheme: (theme) => {
    localStorage.setItem(STORAGE_KEY, theme);
    apply(theme);
    set({ theme });
  },
  toggle: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
}));

/** Vor dem ersten Render aufrufen (main.tsx) — vermeidet Theme-Flackern. */
export function initTheme(): void {
  apply(initial);
}
